import { sendAdminRequest } from '../../api/websocketApi';
import useStore from '../../store/store';

interface UpdateTrfFileStatusParams {
    kitId: number;
    status: 'valid' | 'invalid';
}

interface APIResponse {
    success: boolean;
    errCode?: string;
    errDetails?: string;
}

const UpdateTrfFileStatus = async (params: UpdateTrfFileStatusParams) => {
    const { setFormError, setIsLoading } = useStore.getState();

    setIsLoading(true);
    sendAdminRequest(
        {
            endpoint: '/kit/update-trf-file-status',
            body: params,
        },
        (data: APIResponse) => {
            const { success, errCode, errDetails } = data;
            if (success) {
                setIsLoading(false);
            } else if (!success && errCode) {
                setIsLoading(false);
                setFormError('');
                setTimeout(() => setFormError(errCode), 0);
                console.error(errCode);
                if (errDetails) console.error(errDetails);
            }
        }
    );
};

export default UpdateTrfFileStatus;
